import { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Login.css";
import logoLogin from "../images/logo login.svg";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = () => {
    if (errorMessage) setErrorMessage("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage("");
    setIsSubmitting(true);

    try {
      const response = await fetch(process.env.REACT_APP_RESET_PASSWORD_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      // Independentemente da resposta, mostrar a mesma mensagem
      // por questões de segurança
      setIsSubmitted(true);
    } catch (error) {
      console.error("Erro ao solicitar redefinição de senha:", error);
      // Ainda mostramos a mesma mensagem para o usuário
      setIsSubmitted(true);
    }

    setIsSubmitting(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logoLogin} alt="Logo Login" />

        {errorMessage && (
          <div className="error-message" style={{ display: "block" }}>
            {errorMessage}
          </div>
        )}

        {isSubmitted ? (
          <div className="success-message">
            <h3>Email enviado</h3>
            <p>
              Se o email estiver registrado em nosso sistema, você receberá um
              link para redefinição de senha em breve.
            </p>
            <div className="input-group" style={{ marginTop: "20px" }}>
              <Link to="/" className="button-link">
                Voltar ao Login
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <h3 className="form-title">Esqueceu sua senha?</h3>
            <p className="form-subtitle">
              Informe seu email de cadastro para receber um link de redefinição
              de senha.
            </p>

            <div className="input-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  handleInputChange();
                }}
                required
              />
            </div>

            <div className="input-group">
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Enviando..." : "Enviar"}
              </button>
            </div>

            <div className="input-group">
              <Link to="/" className="back-link">
                Voltar ao Login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;